// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import { BillingOverviewFragmentFragmentDoc } from "../../Overview/gql/Fragment.generated";
import { BillingPlanInfoFragmentFragmentDoc } from "../../PlanInfo/gql/Fragment.generated";
import { WithSubscriptionCheckFragmentDoc } from "../../../../../providers/WithSubscriptionCheck/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FinalizePlanMutationMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type FinalizePlanMutationMutation = {
  __typename?: "Mutation";
  finalizeBillingPlanActivation: {
    __typename?: "FinalizeBillingPlanActivationPayload";
    organizationBilling: {
      __typename?: "OrganizationBilling";
      id: string;
      subscriptionActiveInStripe: boolean;
      subscriptionNextChargeAt?: number | null;
      subscriptionNextChargeAmount?: number | null;
      subscriptionNextChargeCurrency?: string | null;
      subscriptionCardType?: string | null;
      subscriptionCardLast4?: string | null;
      subscriptionCardExpMonth?: number | null;
      subscriptionCardExpYear?: number | null;
      subscriptionBilledManually: boolean;
      subscriptionInterval?: Types.SubscriptionInterval | null;
      billingAddressWithName?: string | null;
      billingVatId?: string | null;
      billingEmail?: string | null;
      paymentRequiresAction: boolean;
      stripeClientSecret?: string | null;
      invoices: Array<{
        __typename?: "Invoice";
        id: string;
        reference: string;
        formattedTotal: string;
        invoicePdf?: string | null;
        status: string;
        created: number;
        hostedInvoiceUrl?: string | null;
      }>;
      planChoices: Array<{
        __typename?: "OrganizationPlanChoice";
        id: string;
        name: string;
        marketingLines: Array<string>;
        notIncludedMarketingLines: Array<string>;
        formattedMonthlyPrice: string;
        formattedServerOveragePrice?: string | null;
        isCurrent: boolean;
        isDowngrade: boolean;
      }>;
    };
    organization: {
      __typename?: "Organization";
      serverLimit?: number | null;
      serverCountForBilling: number;
      id: string;
      permittedToBilling: boolean;
      planInfo: {
        __typename?: "OrganizationPlanInfo";
        id: string;
        activeSubscription: boolean;
        canceledSubscription: boolean;
        subscriptionPlanId: string;
        subscriptionPlanName: string;
        supportsExtraServers: boolean;
        trialEndsAt?: number | null;
        isTrial: boolean;
        expiredTrial: boolean;
        supportsLitePlan: boolean;
        subscriptionCancelationPending: boolean;
        subscriptionCancelationEffectiveAt?: number | null;
      };
    };
  };
};

export const FinalizePlanMutationDocument = gql`
  mutation FinalizePlanMutation($organizationSlug: ID!) {
    finalizeBillingPlanActivation(organizationSlug: $organizationSlug) {
      organizationBilling {
        ...BillingOverviewFragment
      }
      organization {
        ...BillingPlanInfoFragment
        ...WithSubscriptionCheck
        serverLimit
        serverCountForBilling
      }
    }
  }
  ${BillingOverviewFragmentFragmentDoc}
  ${BillingPlanInfoFragmentFragmentDoc}
  ${WithSubscriptionCheckFragmentDoc}
`;
export type FinalizePlanMutationMutationFn = Apollo.MutationFunction<
  FinalizePlanMutationMutation,
  FinalizePlanMutationMutationVariables
>;

/**
 * __useFinalizePlanMutationMutation__
 *
 * To run a mutation, you first call `useFinalizePlanMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizePlanMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizePlanMutationMutation, { data, loading, error }] = useFinalizePlanMutationMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useFinalizePlanMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinalizePlanMutationMutation,
    FinalizePlanMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FinalizePlanMutationMutation,
    FinalizePlanMutationMutationVariables
  >(FinalizePlanMutationDocument, options);
}
export type FinalizePlanMutationMutationHookResult = ReturnType<
  typeof useFinalizePlanMutationMutation
>;
export type FinalizePlanMutationMutationResult =
  Apollo.MutationResult<FinalizePlanMutationMutation>;
export type FinalizePlanMutationMutationOptions = Apollo.BaseMutationOptions<
  FinalizePlanMutationMutation,
  FinalizePlanMutationMutationVariables
>;
